import { render } from "./RemainingInstallmentsPaymentModal.vue?vue&type=template&id=64a88502"
import script from "./RemainingInstallmentsPaymentModal.vue?vue&type=script&lang=js"
export * from "./RemainingInstallmentsPaymentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__